module.exports = __webpack_public_path__ + "static/media/Gotham-ThinItalic.0adc8a0b.ttf";